// extracted by mini-css-extract-plugin
module.exports = {"guest-mode-label-wrapper":"GuestModeLabel_guest-mode-label-wrapper__3K2l1"};